import { useQuery } from '@apollo/client/react';

import { GetMedixsSettingDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useMedixsSetting = () => {
  const { data } = useQuery(GetMedixsSettingDocument);
  const medixsSetting = data ? getMe(data)?.organization.medixsSetting : null;
  const enabledMedixs = !!medixsSetting && medixsSetting.active;

  return {
    medixsSetting,
    enabledMedixs,
  };
};
